

import { usbCertificatesType} from '../reduxExports'


const usbCertificatesInitialState: UsbCertificatesState = {
  usbCertificates: null,
  loader: false,
  usbCertificatesCount: 0,
  usbCertificatesListTableProps: {
    view: 'list',
    sortBy: 'name',
    order: 'ascending',
    pageSize: 15,
    pageNumber: 1,
    searchTerm: ''
  },
  chargerCertificatesInfo:null,
  chargerCertificatesInfoCount:0,
  chargerCertificatesInfoListTableProps: {
    view: 'list',
    sortBy: '',
    order: 'ascending',
    pageSize: 15,
    pageNumber: 1,
    searchTerm: ''
  },
}

const usbCertificatesReducer = (state: UsbCertificatesState = usbCertificatesInitialState, action: UsbCertificatesAction): UsbCertificatesState => {
  switch (action.type) {
    case usbCertificatesType.FETCH_USB_CERTIFICATES_DATA:
      return {
        ...state,
        usbCertificates: action.usbCertificates,
        usbCertificatesCount: action.usbCertificatesCount
      }
    case usbCertificatesType.SET_LOADER:
      return {
        ...state,
        loader: action.loader
      }

    case usbCertificatesType.SET_USB_CERTIFICATES_LIST_TABLE_PROPS:
      return {
        ...state,
        usbCertificatesListTableProps: action.usbCertificatesListTableProps
      }
    case usbCertificatesType.CLEAR_USB_CERTIFICATES_LIST_DATA:
      return {
        ...state,
        // roles: null,
        // rolesCount: 0,
        usbCertificatesListTableProps: {
          view: 'list',
          sortBy: state.usbCertificatesListTableProps?.sortBy || 'name',
          order: state.usbCertificatesListTableProps?.order || 'ascending',
          pageSize: state.usbCertificatesListTableProps?.pageSize || 15,
          pageNumber: state.usbCertificatesListTableProps?.pageNumber || 1,
          searchTerm: ''
        }
      }
      case usbCertificatesType.FETCH_CHARGER_CERTIFICATES_INFO_DATA:
        return {
          ...state,
          chargerCertificatesInfo: action.chargerCertificatesInfo,
          chargerCertificatesInfoCount: action.chargerCertificatesInfoCount
        }
      case usbCertificatesType.SET_CHARGER_CERTIFICATES_INFO_LIST_TABLE_PROPS:
        return {
          ...state,
          chargerCertificatesInfoListTableProps: action.chargerCertificatesInfoListTableProps
        }
      case usbCertificatesType.CLEAR_CHARGER_CERTIFICATES_INFO_LIST_DATA:
        return {
          ...state,
          // roles: null,
          // rolesCount: 0,
          chargerCertificatesInfoListTableProps: {
            view: 'list',
            sortBy: state.chargerCertificatesInfoListTableProps?.sortBy,
            order: state.chargerCertificatesInfoListTableProps?.order || 'ascending',
            pageSize: state.chargerCertificatesInfoListTableProps?.pageSize || 15,
            pageNumber: state.chargerCertificatesInfoListTableProps?.pageNumber || 1,
            searchTerm: ''
          }
        }
    default:
      return state
  }
}

export default usbCertificatesReducer
